enum CountryEnum {
   ESPAÑA = 1,
   ECUADOR = 2,
   ANDORRA = 3
}

export default CountryEnum